import { render, staticRenderFns } from "./ProductFormDesktopView.vue?vue&type=template&id=23ae3669&"
import script from "./ProductFormDesktopView.vue?vue&type=script&lang=js&"
export * from "./ProductFormDesktopView.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormDesktopView.vue?vue&type=style&index=0&id=23ae3669&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports